import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { ChangePassword } from './change-password/change-password';

@Component({
  selector: 'app-security',
  imports: [CommonModule, MatDialogModule],
  templateUrl: './security.html',
  styleUrl: './security.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Security {
  private dialog = inject(MatDialog);

  openChangePasswordDialog(): void {
    this.dialog.open(ChangePassword, {
      width: '700px',
      minWidth: '700px',
      disableClose: false,
      panelClass: 'password-change-dialog'
    });
  }
}
